import { ACTION_TYPES } from './actionTypes';
//const TOOLS = getTools();
/** Default workflow */
export const DEFAULT_WORKFLOW = {
    name: '',
    description: '',
    actions: [
        {
            type: ACTION_TYPES.INPUT,
            name: '',
            //tool: TOOLS.crawlWebpage.value,
            tool: 'crawlWebpage',
            description: '',
            promptContent: '',
            inputs: [
                {
                    name: '',
                    value: '',
                    description: '',
                    type: 'TextField',
                },
            ]
        },
    ],
    category: 'Custom',
    author: 'You',
};
